<template>
  <div class="import-participante-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Código Promoción"
            v-if="solicitaCodigoPromocion">
          <b-form>
            <b-form-group
              label="Cod.Promoción"
              label-for="codigoPromocion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPromocion"
                :value="participante.codigoPromocion" 
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header="Sorteo" v-if="importaGanadores">
          <b-form>
            <b-form-group
              label="Posición"
              label-for="posicionSorteo"
              :label-cols="labelCols"
              description="Posición en el sorteo"
              horizontal>
              <b-input-group>
                <b-form-input 
                  id="posicionSorteo"
                  :value="participante.posicionSorteo" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-form>
          <template slot="footer">
            <small class="text-muted">Sorteo importado a partir de un archivo CSV</small>
          </template>  
        </b-card>

        <b-card header="Información del Participante">
          <b-form>
            <b-form-group
              v-if="eventoSolicitaNombre"
              label="Nombre Completo"
              label-for="nombreCompleto"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreCompleto"
                :value="participante.nombreCompleto" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDatosPersonales"
              label="Fecha Nacimiento"
              label-for="fechaNacimiento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaNacimiento"
                :value="participante.fechaNacimiento | fecha" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDocumento"
              label="Nro.Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                :value="participante.documentoNumero" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDatosPersonales"
              label="Sexo"
              label-for="sexo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="sexo"
                :value="participante.sexo" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaEmail"
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                :value="participante.email" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaTelefono"
              label="Nro.Celular"
              label-for="numeroCelular"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCelular"
                :value="participante.numeroCelular" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Provincia"
              label-for="provincia"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="provincia"
                :value="participante.provincia" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaLocalidad"
              label="Localidad"
              label-for="localidad"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="localidad"
                :value="participante.localidad" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaBarrio"
              label="Barrio"
              label-for="barrio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="barrio"
                :value="participante.barrio" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Dirección"
              label-for="direccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccion"
                :value="participante.direccion" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Cod.Postal"
              label-for="codigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPostal"
                :value="participante.codigoPostal" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoValidaNumeroCliente"
              label="Cliente Previo"
              label-for="clientePrevio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="clientePrevio"
                :value="participante.clientePrevio" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoValidaNumeroCliente"
              label="Nro.Cliente"
              label-for="numeroCliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCliente"
                :value="participante.numeroCliente" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                :value="participante.observaciones" 
                rows="3"
                max-rows="3"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>

        <!-- <b-card header="Información Bancaria"
            v-if="requiereInformacionBancaria">
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco"
                :value="participante.banco" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="CBU"
              label-for="cbu"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbu"
                :value="participante.cbu" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="CBU Alias"
              label-for="cbuAlias"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbuAlias"
                :value="participante.cbuAlias" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="Titular"
              label-for="titularCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titularCuenta"
                :value="participante.titularCuenta" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="CUIT"
              label-for="titularCuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titularCuit"
                :value="participante.titularCuit" 
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card> -->

        <!-- <b-card header="Información del Negocio"
            v-if="participacionNegocios">
          <b-form>
            <b-form-group
              v-if="eventoSolicitaPosicionNegocio"
              label="Posición"
              label-for="posicion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="posicion"
                :value="participante.negocio.posicion" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                :value="participante.negocio.nombreComercial" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaRazonSocialNegocio"
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                :value="participante.negocio.razonSocial" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDocumentoNegocio"
              label="CUIT"
              label-for="negocioCuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioCuit"
                :value="participante.negocio.cuit" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Pais"
              label-for="negocioPais"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioPais"
                :value="participante.negocio.pais" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Provincia"
              label-for="negocioProvincia"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioProvincia"
                :value="participante.negocio.provincia" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaLocalidadNegocio"
              label="Localidad"
              label-for="negocioLocalidad"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioLocalidad"
                :value="participante.negocio.localidad" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaBarrioNegocio"
              label="Barrio"
              label-for="negocioBarrio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioBarrio"
                :value="participante.negocio.barrio" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Direccion"
              label-for="negocioDireccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioDireccion"
                :value="participante.negocio.direccion" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Cod.Postal"
              label-for="negocioCodigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioCodigoPostal"
                :value="participante.negocio.codigoPostal" 
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card> -->

        <b-card header= "Campos Adicionales" v-if="tieneCamposAdicionales">
          <b-form>
            <b-form-group
              v-for="(campoAdicional, index) in participante.camposAdicionales"
              :key="index"
              :label="campoAdicional.campo"
              :label-for="campoAdicional.id"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                :id="campoAdicional.id"
                :value="campoAdicional.valor"
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'importParticipante/getField',
  mutationType: 'importParticipante/updateField',
});

export default {
  name: 'ImportParticipanteDatos',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'eventoId',
      'importParticipantesId',
      'participanteId',

      'evento',
      'participante',
    ]),
    // participacionNegocios() {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.participacionNegocios);
    //   }
    //   return false;
    // },
    // requiereInformacionBancaria() {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.requiereInformacionBancaria);
    //   }
    //   return false;
    // },
    solicitaCodigoPromocion () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaCodigoPromocion);
      }
      return false;
    },
    importaGanadores () {
      if (this.evento) {
        return (/true/i).test(this.evento.importaGanadores);
      }
      return false;
    },
    tieneCamposAdicionales () {
      if (this.participante) {
        if (this.participante.camposAdicionales) {
          return this.participante.camposAdicionales.length != 0;
        }
      }
      return false;
    },
    eventoSolicitaNombre () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaNombre);
      }
      return false;
    },
    eventoSolicitaDocumento () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaDocumento);
      }
      return false;
    },
    eventoSolicitaUbicacion () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaUbicacion);
      }
      return false;
    },
    eventoSolicitaLocalidad () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaLocalidad);
      }
      return false;
    },
    eventoSolicitaBarrio () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaBarrio);
      }
      return false;
    },
    eventoSolicitaDatosPersonales () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaDatosPersonales);
      }
      return false;
    },
    eventoSolicitaTelefono () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaTelefono);
      }
      return false;
    },
    eventoSolicitaEmail () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaEmail);
      }
      return false;
    },
    eventoValidaNumeroCliente () {
      if (this.evento) {
        return (/true/i).test(this.evento.validaNumeroCliente);
      }
      return false;
    },
    // eventoSolicitaPosicionNegocio() {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.solicitaPosicionNegocio);
    //   }
    //   return false;
    // },
    // eventoSolicitaRazonSocialNegocio() {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.solicitaRazonSocialNegocio);
    //   }
    //   return false;
    // },
    // eventoSolicitaDocumentoNegocio() {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.solicitaDocumentoNegocio);
    //   }
    //   return false;
    // },
    // eventoSolicitaUbicacionNegocio() {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.solicitaUbicacionNegocio);
    //   }
    //   return false;
    // },
    // eventoSolicitaLocalidadNegocio () {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.solicitaLocalidadNegocio);
    //   }
    //   return false;
    // },
    // eventoSolicitaBarrioNegocio () {
    //   if (this.evento) {
    //     return (/true/i).test(this.evento.solicitaBarrioNegocio);
    //   }
    //   return false;
    // },
  },
  created() {
    // if ((/true/i).test(this.$store.getters['user/admin'])) {
    //   this.editarHabilitado = true;
    //   this.borrarHabilitado = true;
    // }

    let eventoId = 0;
    let importParticipantesId = 0;
    let participanteId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        eventoId = this.$route.params.eventoId;
      }
      if (this.$route.params.importParticipantesId){
        importParticipantesId = this.$route.params.importParticipantesId;
      }
      if (this.$route.params.id){
        participanteId = this.$route.params.id;
      }
    }

    let params = {
      eventoId,
      importParticipantesId,
      participanteId
    }

    this.showSpinner();
    this.$store.dispatch('importParticipante/getDatos', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
  }   
}
</script>

<style>
</style>